import { InlineNotification } from '@carbon/react';
import { useLoadableAtomValue } from 'lib/hooks/useLoadableAtomValue';
import { TractNRI } from 'components/nri-table/types';
import { SlotRollupNRITable } from 'pages/crm-tracts-subtracts/nri/slot-rollup-nri-table';
import { entitySlotNriAtom } from './atoms';
import style from './slot-table.module.scss';

interface SlotTableProps {
  entityId: number;
}

export const SlotTable = ({ entityId }: SlotTableProps) => {
  const nriData = useLoadableAtomValue<TractNRI[], Error>(
    entitySlotNriAtom(entityId)
  );

  const isLoading = nriData.state === 'loading';
  const hasError = nriData.state === 'hasError';
  const slots = nriData.state === 'hasData' ? nriData.data : [];

  return (
    <div className={style.slotTable}>
      {hasError && (
        <InlineNotification
          kind="error"
          title={nriData.error.message}
          lowContrast
        />
      )}
      <SlotRollupNRITable
        slotNRIRows={slots}
        isLoading={isLoading}
        tableId="entity-tab-slot-table"
      />
    </div>
  );
};
